{
  "labels": {
    "paste": "Lim inn",
    "pasteAsPlaintext": "Lim inn som klartekst",
    "pasteCharts": "Lim inn diagrammer",
    "selectAll": "Velg alt",
    "multiSelect": "Legg til element i utvalg",
    "moveCanvas": "Flytt lerretet",
    "cut": "Klipp ut",
    "copy": "Kopier",
    "copyAsPng": "Kopier til PNG",
    "copyAsSvg": "Kopier til utklippstavlen som SVG",
    "copyText": "Kopier til utklippstavlen som tekst",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Flytt framover",
    "sendToBack": "Send bakerst",
    "bringToFront": "Flytt forrest",
    "sendBackward": "Send bakover",
    "delete": "Slett",
    "copyStyles": "Kopier stiler",
    "pasteStyles": "Lim inn stiler",
    "stroke": "Strek",
    "background": "Bakgrunn",
    "fill": "Fyll",
    "strokeWidth": "Strektykkelse",
    "strokeStyle": "Strekstil",
    "strokeStyle_solid": "Heltrukket",
    "strokeStyle_dashed": "Stiplet",
    "strokeStyle_dotted": "Prikket",
    "sloppiness": "Ujevnhet",
    "opacity": "Synlighet",
    "textAlign": "Tekstjustering",
    "edges": "Kanter",
    "sharp": "Skarp",
    "round": "Rund",
    "arrowheads": "Pilspisser",
    "arrowhead_none": "Ingen",
    "arrowhead_arrow": "Pil",
    "arrowhead_bar": "Søyle",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Trekant",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Skriftstørrelse",
    "fontFamily": "Fontfamilie",
    "addWatermark": "Legg til \"Laget med Excalidraw\"",
    "handDrawn": "Håndtegnet",
    "normal": "Normal",
    "code": "Kode",
    "small": "Liten",
    "medium": "Medium",
    "large": "Stor",
    "veryLarge": "Svært stor",
    "solid": "Helfarge",
    "hachure": "Skravert",
    "zigzag": "Sikk-sakk",
    "crossHatch": "Krysskravert",
    "thin": "Tynn",
    "bold": "Tykk",
    "left": "Venstre",
    "center": "Midtstill",
    "right": "Høyre",
    "extraBold": "Ekstra tykk",
    "architect": "Arkitekt",
    "artist": "Kunstner",
    "cartoonist": "Tegner",
    "fileTitle": "Filnavn",
    "colorPicker": "Fargevelger",
    "canvasColors": "Brukes på lerretet",
    "canvasBackground": "Lerretsbakgrunn",
    "drawingCanvas": "Lerret",
    "layers": "Lag",
    "actions": "Handlinger",
    "language": "Språk",
    "liveCollaboration": "Sanntids-samarbeid...",
    "duplicateSelection": "Dupliser",
    "untitled": "Uten navn",
    "name": "Navn",
    "yourName": "Ditt navn",
    "madeWithExcalidraw": "Laget med Excalidraw",
    "group": "Gruppér utvalg",
    "ungroup": "Avgruppér utvalg",
    "collaborators": "Samarbeidspartnere",
    "showGrid": "Vis rutenett",
    "addToLibrary": "Legg til i bibliotek",
    "removeFromLibrary": "Fjern fra bibliotek",
    "libraryLoadingMessage": "Laster bibliotek…",
    "libraries": "Bla gjennom biblioteker",
    "loadingScene": "Laster inn scene…",
    "align": "Juster",
    "alignTop": "Juster øverst",
    "alignBottom": "Juster nederst",
    "alignLeft": "Juster venstre",
    "alignRight": "Juster høyre",
    "centerVertically": "Midtstill vertikalt",
    "centerHorizontally": "Midtstill horisontalt",
    "distributeHorizontally": "Distribuer horisontalt",
    "distributeVertically": "Distribuer vertikalt",
    "flipHorizontal": "Snu horisontalt",
    "flipVertical": "Snu vertikalt",
    "viewMode": "Visningsmodus",
    "share": "Del",
    "showStroke": "Vis fargevelger for kantfarge",
    "showBackground": "Vis fargevelger for bakgrunnsfarge",
    "toggleTheme": "Veksle tema",
    "personalLib": "Personlig bibliotek",
    "excalidrawLib": "Excalidraw-bibliotek",
    "decreaseFontSize": "Reduser skriftstørrelse",
    "increaseFontSize": "Øk skriftstørrelse",
    "unbindText": "Avbind tekst",
    "bindText": "Bind tekst til beholderen",
    "createContainerFromText": "La tekst flyte i en beholder",
    "link": {
      "edit": "Rediger lenke",
      "editEmbed": "Rediger lenke og bygg inn",
      "create": "Opprett lenke",
      "createEmbed": "Opprett lenke og bygg inn",
      "label": "Lenke",
      "labelEmbed": "Lenk & bygg inn",
      "empty": "Ingen lenke er valgt"
    },
    "lineEditor": {
      "edit": "Rediger linje",
      "exit": "Avslutt linjeredigering"
    },
    "elementLock": {
      "lock": "Lås",
      "unlock": "Lås opp",
      "lockAll": "Lås alle",
      "unlockAll": "Lås opp alle"
    },
    "statusPublished": "Publisert",
    "sidebarLock": "Holde sidemenyen åpen",
    "selectAllElementsInFrame": "Velg alle elementene i rammen",
    "removeAllElementsFromFrame": "Fjern alle elementer fra rammen",
    "eyeDropper": "Velg farge fra lerretet",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "Ingen elementer lagt til ennå...",
    "hint_emptyLibrary": "Velg et objekt på lerretet for å legge det til her, eller installer et bibliotek fra den offentlige samlingen under.",
    "hint_emptyPrivateLibrary": "Velg et objekt på lerretet for å legge det til her."
  },
  "buttons": {
    "clearReset": "Tøm lerretet og tilbakestill bakgrunnsfargen",
    "exportJSON": "Eksporter til fil",
    "exportImage": "Eksporter bilde...",
    "export": "Lagre som...",
    "copyToClipboard": "Kopier til utklippstavle",
    "save": "Lagre til aktiv fil",
    "saveAs": "Lagre som",
    "load": "Åpne",
    "getShareableLink": "Få delingslenke",
    "close": "Lukk",
    "selectLanguage": "Velg språk",
    "scrollBackToContent": "Skroll tilbake til innhold",
    "zoomIn": "Zoom inn",
    "zoomOut": "Zoom ut",
    "resetZoom": "Nullstill zoom",
    "menu": "Meny",
    "done": "Ferdig",
    "edit": "Rediger",
    "undo": "Angre",
    "redo": "Gjør om",
    "resetLibrary": "Nullstill bibliotek",
    "createNewRoom": "Opprett et nytt rom",
    "fullScreen": "Fullskjerm",
    "darkMode": "Mørk modus",
    "lightMode": "Lys modus",
    "zenMode": "Zen-modus",
    "objectsSnapMode": "",
    "exitZenMode": "Avslutt zen-modus",
    "cancel": "Avbryt",
    "clear": "Tøm",
    "remove": "Fjern",
    "embed": "Slå av/på innebygging",
    "publishLibrary": "Publiser",
    "submit": "Send inn",
    "confirm": "Bekreft",
    "embeddableInteractionButton": "Klikk for å samhandle"
  },
  "alerts": {
    "clearReset": "Dette vil tømme lerretet. Er du sikker?",
    "couldNotCreateShareableLink": "Kunne ikke lage delbar lenke.",
    "couldNotCreateShareableLinkTooBig": "Kunne ikke opprette lenke til deling: scenen er for stor",
    "couldNotLoadInvalidFile": "Kunne ikke laste inn ugyldig fil",
    "importBackendFailed": "Importering av backend feilet.",
    "cannotExportEmptyCanvas": "Kan ikke eksportere et tomt lerret.",
    "couldNotCopyToClipboard": "Kunne ikke kopiere til utklippstavlen.",
    "decryptFailed": "Kunne ikke dekryptere data.",
    "uploadedSecurly": "Opplastingen er kryptert og kan ikke leses av Excalidraw-serveren eller tredjeparter.",
    "loadSceneOverridePrompt": "Å laste inn ekstern tegning vil erstatte det eksisterende innholdet. Ønsker du å fortsette?",
    "collabStopOverridePrompt": "Hvis du slutter økten, overskrives din forrige, lokalt lagrede tegning. Er du sikker?\n\n(Hvis du ønsker å beholde din lokale tegning, bare lukk nettleserfanen i stedet.)",
    "errorAddingToLibrary": "Kunne ikke legge element i biblioteket",
    "errorRemovingFromLibrary": "Kunne ikke fjerne element fra biblioteket",
    "confirmAddLibrary": "Dette vil legge til {{numShapes}} figur(er) i biblioteket ditt. Er du sikker?",
    "imageDoesNotContainScene": "Det ser ikke ut til at dette bildet inneholder noen scenedata. Har du aktivert innebygging av scene under eksporten?",
    "cannotRestoreFromImage": "Scenen kunne ikke gjenopprettes fra denne bildefilen",
    "invalidSceneUrl": "Kunne ikke importere scene fra den oppgitte URL-en. Den er enten ødelagt, eller inneholder ikke gyldig Excalidraw JSON-data.",
    "resetLibrary": "Dette vil tømme biblioteket ditt. Er du sikker?",
    "removeItemsFromsLibrary": "Slett {{count}} element(er) fra biblioteket?",
    "invalidEncryptionKey": "Krypteringsnøkkel må ha 22 tegn. Live-samarbeid er deaktivert.",
    "collabOfflineWarning": "Ingen Internett-tilkobling tilgjengelig.\nEndringer dine vil ikke bli lagret!"
  },
  "errors": {
    "unsupportedFileType": "Filtypen støttes ikke.",
    "imageInsertError": "Kunne ikke sette inn bildet. Prøv igjen senere...",
    "fileTooBig": "Filen er for stor. Maksimal tillatt størrelse er {{maxSize}}.",
    "svgImageInsertError": "Kunne ikke sette inn SVG-bilde. SVG-koden ser ugyldig ut.",
    "failedToFetchImage": "",
    "invalidSVGString": "Ugyldig SVG.",
    "cannotResolveCollabServer": "Kunne ikke koble til samarbeidsserveren. Vennligst oppdater siden og prøv på nytt.",
    "importLibraryError": "Kunne ikke laste bibliotek",
    "collabSaveFailed": "Kan ikke lagre i backend-databasen. Hvis problemer vedvarer, bør du lagre filen lokalt for å sikre at du ikke mister arbeidet.",
    "collabSaveFailed_sizeExceeded": "Kunne ikke lagre til backend-databasen, lerretet ser ut til å være for stort. Du bør lagre filen lokalt for å sikre at du ikke mister arbeidet ditt.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "Ser ut som om du bruker Brave nettleser med <bold>Aggressivt Block Finger</bold> -innstillingen aktivert.",
      "line2": "Dette kan resultere i å bryte <bold>tekst-elementene</bold> i tegningene.",
      "line3": "Vi anbefaler på det sterkeste å deaktivere denne innstillingen. Du kan følge <link>disse trinnene</link> om hvordan du gjør det.",
      "line4": "Hvis deaktivering av denne innstillingen ikke fikser visningen av tekstelementer, vennligst åpne en <issueLink>sak</issueLink> på vår GitHub, eller skriv oss på <discordLink>Discord</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "Innebygde elementer kan ikke legges til i biblioteket.",
      "iframe": "",
      "image": "Støtte for å legge til bilder i biblioteket kommer snart!"
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Velg",
    "image": "Sett inn bilde",
    "rectangle": "Rektangel",
    "diamond": "Diamant",
    "ellipse": "Ellipse",
    "arrow": "Pil",
    "line": "Linje",
    "freedraw": "Tegn",
    "text": "Tekst",
    "library": "Bibliotek",
    "lock": "Behold merket verktøy som aktivt",
    "penMode": "Pennemodus - forhindre berøring",
    "link": "Legg til / oppdater link for en valgt figur",
    "eraser": "Viskelær",
    "frame": "Rammeverktøy",
    "magicframe": "",
    "embeddable": "Nettinnbygging",
    "laser": "",
    "hand": "Hånd (panoreringsverktøy)",
    "extraTools": "Flere verktøy",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "Handlinger: lerret",
    "selectedShapeActions": "Handlinger: valgt objekt",
    "shapes": "Former"
  },
  "hints": {
    "canvasPanning": "For å flytte lerretet, hold musehjulet eller mellomromstasten mens du drar, eller bruk hånd-verktøyet",
    "linearElement": "Klikk for å starte linje med flere punkter, eller dra for en enkel linje",
    "freeDraw": "Klikk og dra, slipp når du er ferdig",
    "text": "Tips: du kan også legge til tekst ved å dobbeltklikke hvor som helst med utvalgsverktøyet",
    "embeddable": "Klikk og dra for å opprette en nettside innebygd",
    "text_selected": "Dobbeltklikk eller trykk ENTER for å redigere tekst",
    "text_editing": "Trykk Escape eller Ctrl/Cmd+Enter for å fullføre redigering",
    "linearElementMulti": "Klikk på siste punkt eller trykk Escape eller Enter for å fullføre",
    "lockAngle": "Du kan låse vinkelen ved å holde nede SHIFT",
    "resize": "Du kan beholde forholdet ved å trykke SHIFT mens du endrer størrelse,\ntrykk ALT for å endre størrelsen fra midten",
    "resizeImage": "Du kan endre størrelse fritt ved å holde SHIFT,\nhold ALT for å endre størrelse fra midten",
    "rotate": "Du kan låse vinklene ved å holde SHIFT mens du roterer",
    "lineEditor_info": "Hold Ctrl/Cmd og dobbelklikk eller trykk Ctrl/Cmd + Enter for å endre punkter",
    "lineEditor_pointSelected": "Trykk på Slett for å fjerne punktet, Ctrl / Cmd+D for å duplisere, eller dra for å flytte",
    "lineEditor_nothingSelected": "Velg et punkt å redigere (hold SHIFT for å velge flere),\neller hold Alt og klikk for å legge til nye punkter",
    "placeImage": "Klikk for å plassere bildet, eller klikk og dra for å angi størrelsen manuelt",
    "publishLibrary": "Publiser ditt eget bibliotek",
    "bindTextToElement": "Trykk Enter for å legge til tekst",
    "deepBoxSelect": "Hold CTRL/CMD for å markere dypt og forhindre flytting",
    "eraserRevert": "Hold Alt for å reversere elementene merket for sletting",
    "firefox_clipboard_write": "Denne funksjonen kan sannsynligvis aktiveres ved å sette \"dom.events.asyncClipboard.clipboardItem\" flagget til \"true\". For å endre nettleserens flagg i Firefox, besøk \"about:config\"-siden.",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "Kan ikke vise forhåndsvisning",
    "canvasTooBig": "Lerretet kan være for stort.",
    "canvasTooBigTip": "Tips: Prøv å flytte de ytterste elementene litt tettere sammen."
  },
  "errorSplash": {
    "headingMain": "En feil oppsto. Prøv <button>å laste siden på nytt.</button>",
    "clearCanvasMessage": "Om ny sidelasting ikke fungerer, prøv <button>å tømme lerretet.</button>",
    "clearCanvasCaveat": " Dette vil føre til tap av arbeid ",
    "trackedToSentry": "Feilen med identifikator {{eventId}} ble logget i vårt system.",
    "openIssueMessage": "Vi er veldig nøye med å ikke inkludere dine scene-opplysninger i feilen. Hvis din scene ikke er privat, vurder å følge opp i vårt <button>feilrapporteringssystem.</button> Ta med opplysningene nedenfor ved å kopiere og lime inn i GitHub-saken.",
    "sceneContent": "Scene-innhold:"
  },
  "roomDialog": {
    "desc_intro": "Du kan invitere personer til scenen din for å samarbeide med deg.",
    "desc_privacy": "Ta det med ro, sesjonen bruker ende-til-ende-kryptering, så alt du tegner forblir privat. Ikke en gang serveren vår kan se hva du lager.",
    "button_startSession": "Start økt",
    "button_stopSession": "Stopp sesjon",
    "desc_inProgressIntro": "Sanntids-samarbeidsøkt er nå i gang.",
    "desc_shareLink": "Del denne linken med de du vil samarbeide med:",
    "desc_exitSession": "Dersom du avslutter sesjonen blir du frakoblet rommet, men du kan fortsette å arbeide med scenen lokalt. Vær oppmerksom på at dette ikke vil påvirke andre personer, og de vil fortsatt ha mulighet til å samarbeide på deres versjon.",
    "shareTitle": "Bli med i en live samarbeidsøkt på Excalidraw"
  },
  "errorDialog": {
    "title": "Feil"
  },
  "exportDialog": {
    "disk_title": "Lagre til disk",
    "disk_details": "Eksporter scene-dataene til en fil som du kan importere fra senere.",
    "disk_button": "Lagre til fil",
    "link_title": "Delbar lenke",
    "link_details": "Eksporter som en skrivebeskyttet lenke.",
    "link_button": "Eksporter til lenke",
    "excalidrawplus_description": "Lagre scenen til ditt Excalidraw+ arbeidsområde.",
    "excalidrawplus_button": "Eksporter",
    "excalidrawplus_exportError": "Kunne ikke eksportere til Excalidraw+ for øyeblikket..."
  },
  "helpDialog": {
    "blog": "Les bloggen vår",
    "click": "klikk",
    "deepSelect": "Marker dypt",
    "deepBoxSelect": "Marker dypt innad i boks og forhindre flytting",
    "curvedArrow": "Buet pil",
    "curvedLine": "Buet linje",
    "documentation": "Dokumentasjon",
    "doubleClick": "dobbeltklikk",
    "drag": "dra",
    "editor": "Redigeringsvisning",
    "editLineArrowPoints": "Rediger linje/pilpunkter",
    "editText": "Rediger tekst / legg til etikett",
    "github": "Funnet et problem? Send inn",
    "howto": "Følg våre veiledninger",
    "or": "eller",
    "preventBinding": "Forhindre pilbinding",
    "tools": "Verktøy",
    "shortcuts": "Tastatursnarveier",
    "textFinish": "Fullfør redigering (teksteditor)",
    "textNewLine": "Legg til ny linje (teksteditor)",
    "title": "Hjelp",
    "view": "Vis",
    "zoomToFit": "Zoom for å se alle elementer",
    "zoomToSelection": "Zoom til utvalg",
    "toggleElementLock": "Lås/lås opp utvalg",
    "movePageUpDown": "Flytt side opp/ned",
    "movePageLeftRight": "Flytt siden til venstre/høyre"
  },
  "clearCanvasDialog": {
    "title": "Tøm lerret"
  },
  "publishDialog": {
    "title": "Publiser bibliotek",
    "itemName": "Elementnavn",
    "authorName": "Forfatterens navn",
    "githubUsername": "GitHub-brukernavnet",
    "twitterUsername": "Twitter-brukernavn",
    "libraryName": "Biblioteknavn",
    "libraryDesc": "Beskrivelse av bibliotek",
    "website": "Nettsted",
    "placeholder": {
      "authorName": "Ditt navn eller brukernavn",
      "libraryName": "Navnet på biblioteket ditt",
      "libraryDesc": "Beskrivelse av biblioteket ditt for å hjelpe folk med å forstå bruken",
      "githubHandle": "Github-brukernavn (valgfritt), slik at du kan redigere biblioteket når du har sendt inn for gjennomgang",
      "twitterHandle": "Twitter-brukernavn (valgfritt), slik at vi vet hvem vi skal kreditere når promotert på Twitter",
      "website": "Lenke til din personlige nettside eller et annet sted (valgfritt)"
    },
    "errors": {
      "required": "Påkrevd",
      "website": "Angi en gyldig nettadresse"
    },
    "noteDescription": "Send inn biblioteket ditt som skal inkluderes i <link>kildekode for offentlig bibliotek</link>for andre å bruke dem i tegninger.",
    "noteGuidelines": "Biblioteket må godkjennes manuelt først. Les <link>retningslinjene</link> før innsending. Du vil trenge en GitHub-konto for å kommunisere og gjøre endringer hvis ønsket, men det er ikke påkrevd.",
    "noteLicense": "Ved å sende inn godtar du at biblioteket blir publisert under <link>MIT-lisens, </link>som kortfattet betyr at andre kan bruke dem uten begrensninger.",
    "noteItems": "Hvert bibliotek må ha sitt eget navn, så det er filtrerbart. Følgende bibliotekselementer vil bli inkludert:",
    "atleastOneLibItem": "Vennligst velg minst ett bibliotek for å komme i gang",
    "republishWarning": "Merk: noen av de valgte elementene er merket som allerede publisert/sendt. Du bør kun sende inn elementer på nytt når du oppdaterer et eksisterende bibliotek eller innlevering."
  },
  "publishSuccessDialog": {
    "title": "Bibliotek innsendt",
    "content": "Takk {{authorName}}. Ditt bibliotek har blitt sendt inn for gjennomgang. Du kan spore statusen<link>her</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Nullstill bibliotek",
    "removeItemsFromLib": "Fjern valgte elementer fra bibliotek"
  },
  "imageExportDialog": {
    "header": "Eksporter bilde",
    "label": {
      "withBackground": "Bakgrunn",
      "onlySelected": "Kun valgte",
      "darkMode": "Mørk modus",
      "embedScene": "Bygg inn scene",
      "scale": "Skalering",
      "padding": "Avstand"
    },
    "tooltip": {
      "embedScene": "Scenedata vil bli lagret i den eksporterte PNG/SVG-filen, slik at scenen kan gjenopprettes fra den.\nDet vil øke den eksporterte filstørrelsen."
    },
    "title": {
      "exportToPng": "Eksporter til PNG",
      "exportToSvg": "Eksporter til SVG",
      "copyPngToClipboard": "Kopier PNG til utklippstavlen"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Kopier til utklippstavle"
    }
  },
  "encrypted": {
    "tooltip": "Dine tegninger er ende-til-ende-krypterte slik at Excalidraw sine servere aldri vil se dem.",
    "link": "Blogginnlegg om ende-til-ende-kryptering i Excalidraw"
  },
  "stats": {
    "angle": "Vinkel",
    "element": "Element",
    "elements": "Elementer",
    "height": "Høyde",
    "scene": "Scene",
    "selected": "Valgt",
    "storage": "Lagring",
    "title": "Statistikk for nerder",
    "total": "Totalt",
    "version": "Versjon",
    "versionCopy": "Klikk for å kopiere",
    "versionNotAvailable": "Versjon ikke tilgjengelig",
    "width": "Bredde"
  },
  "toast": {
    "addedToLibrary": "Lagt til i biblioteket",
    "copyStyles": "Kopierte stiler.",
    "copyToClipboard": "Kopiert til utklippstavlen.",
    "copyToClipboardAsPng": "Kopierte {{exportSelection}} til utklippstavlen som PNG\n({{exportColorScheme}})",
    "fileSaved": "Fil lagret.",
    "fileSavedToFilename": "Lagret til {filename}",
    "canvas": "lerret",
    "selection": "utvalg",
    "pasteAsSingleElement": "Bruk {{shortcut}} for å lime inn som ett enkelt element,\neller lim inn i en eksisterende tekstbehandler",
    "unableToEmbed": "Innbygging av denne nettadressen er ikke tillatt. Oppret en sak på GitHub for å be om url-hvitelisting",
    "unrecognizedLinkFormat": "Linken du bygget inn samsvarer ikke med det forventede formatet. Prøv å lime inn \"bygg inn\"-strengen fra kildesiden"
  },
  "colors": {
    "transparent": "Gjennomsiktig",
    "black": "Svart",
    "white": "Hvit",
    "red": "Rød",
    "pink": "Rosa",
    "grape": "Drue",
    "violet": "Fiolett",
    "gray": "Grå",
    "blue": "Blå",
    "cyan": "Turkis",
    "teal": "Blågrønn",
    "green": "Grønn",
    "yellow": "Gul",
    "orange": "Oransje",
    "bronze": "Bronse"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Alle dine data lagres lokalt i din nettleser.",
      "center_heading_plus": "Ønsker du å gå til Excalidraw+ i stedet?",
      "menuHint": "Eksporter, innstillinger, språk, ..."
    },
    "defaults": {
      "menuHint": "Eksporter, innstillinger og mer...",
      "center_heading": "Diagrammer. Gjort. Enkelt.",
      "toolbarHint": "Velg et verktøy og start å tegne!",
      "helpHint": "Snarveier & hjelp"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "Mest brukte egendefinerte farger",
    "colors": "Farger",
    "shades": "Toner",
    "hexCode": "Heksadesimal kode",
    "noShades": "Ingen toner tilgjengelig for denne fargen"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Eksporter som bilde",
        "button": "Eksporter som bilde",
        "description": "Eksporter scene-dataene til en fil som du kan importere fra senere."
      },
      "saveToDisk": {
        "title": "Lagre til disk",
        "button": "Lagre til disk",
        "description": "Eksporter scene-dataene til en fil som du kan importere fra senere."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Eksporter til Excalidraw+",
        "description": "Lagre scenen til ditt Excalidraw+-arbeidsområde."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Last inn fra fil",
        "button": "Last inn fra fil",
        "description": "Å laste fra en fil vil <bold>erstatte ditt eksisterende innhold</bold>.<br></br>Du kan sikkerhetskopiere tegningen din først ved å bruke en av valgene under."
      },
      "shareableLink": {
        "title": "Last inn fra lenke",
        "button": "Erstatt innholdet mitt",
        "description": "Lasting av ekstern tegning vil <bold>erstatte ditt eksisterende innhold</bold>.<br></br>Du kan sikkerhetskopiere tegningen din først ved å bruke en av valgene nedenfor."
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
